module.exports = __webpack_public_path__ + "img/icon02.f27d6320.png";